module.exports = __webpack_public_path__ + "src/assets/img/light_turn_l.942ab1e1.svg";